import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { register as registerAgGridModules } from '@montebravo.tech/design-system-aggrid';
import * as Sentry from '@sentry/angular-ivy';
registerAgGridModules();

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Sentry.init({
    environment: environment.name,
    dsn: 'https://33acb71fe870d546131a0fa2dc79f29e@o4504487409876992.ingest.us.sentry.io/4509322054860800',
    integrations: [
        new Sentry.BrowserTracing({
            tracePropagationTargets: [environment.apiUrl],
            routingInstrumentation: Sentry.routingInstrumentation,
        }),
    ],

    tracesSampleRate: 1.0,
});

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
